/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_about = /** @type {(inputs: {}) => string} */ () => {
	return `O nás`
};

const da_about = /** @type {(inputs: {}) => string} */ () => {
	return `Om os`
};

const de_about = /** @type {(inputs: {}) => string} */ () => {
	return `Über uns`
};

const en_about = /** @type {(inputs: {}) => string} */ () => {
	return `About`
};

const es_about = /** @type {(inputs: {}) => string} */ () => {
	return `Acerca de`
};

const fr_about = /** @type {(inputs: {}) => string} */ () => {
	return `À propos`
};

const hu_about = /** @type {(inputs: {}) => string} */ () => {
	return `Rólunk`
};

const it_about = /** @type {(inputs: {}) => string} */ () => {
	return `Chi siamo`
};

const nl_about = /** @type {(inputs: {}) => string} */ () => {
	return `Over`
};

const pl_about = /** @type {(inputs: {}) => string} */ () => {
	return `O nas`
};

const pt_about = /** @type {(inputs: {}) => string} */ () => {
	return `Sobre`
};

const sv_about = /** @type {(inputs: {}) => string} */ () => {
	return `Om oss`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("about", locale)
	if (locale === "cs") return cs_about(inputs)
	if (locale === "da") return da_about(inputs)
	if (locale === "de") return de_about(inputs)
	if (locale === "en") return en_about(inputs)
	if (locale === "es") return es_about(inputs)
	if (locale === "fr") return fr_about(inputs)
	if (locale === "hu") return hu_about(inputs)
	if (locale === "it") return it_about(inputs)
	if (locale === "nl") return nl_about(inputs)
	if (locale === "pl") return pl_about(inputs)
	if (locale === "pt") return pt_about(inputs)
	return sv_about(inputs)
};